import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
const USButton = styled.button `
  border: none;
  background: none;
  font-size: inherit;
  font-family: inherit;
  text-align: inherit;
  color: inherit;
  display: inline-block;
  padding: 0;
  margin: 0;
`;
/**
 *
 */
const UnstyledButton = forwardRef(({ children, ...rest }, ref) => {
    return (<USButton {...rest} ref={ref}>
        {children}
      </USButton>);
});
export default UnstyledButton;
